// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const founders = document.querySelectorAll('.founders__item');

    for (const founder of founders) {
        const founderContainer = founder.querySelector('.founders__clip');
        const founderMore = founder.querySelector('.founders__more');

        if (founderContainer.offsetHeight > 400) {
            founderContainer.classList.add('founders__clip--active');
        } else {
            founderContainer.classList.remove('founders__clip--active');
        }

        founderMore.addEventListener('click', (e) => {
            e.preventDefault();
            founderContainer.classList.remove('founders__clip--active');
            founderMore.style.display = "none";
        });
    }

});
